import { render, staticRenderFns } from "./SeniorCitizenPwdForm.vue?vue&type=template&id=11f35cbd&scoped=true"
import script from "./SeniorCitizenPwdForm.vue?vue&type=script&lang=js"
export * from "./SeniorCitizenPwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f35cbd",
  null
  
)

export default component.exports